import { getPatientBloodPressure } from 'api/controllers/blood-pressure-controller';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { type AsyncThunkConfig, type BloodPressureResponseDto, type PatientTableItem } from 'types/types';

const getPatientsBloodPressure = createAsyncThunk<
  PromiseSettledResult<BloodPressureResponseDto[]>[],
  PatientTableItem[]
>('bloodPressure/getPatientsBloodPressure', async (patients) => {
  return await Promise.allSettled(patients.map((patient) => getPatientBloodPressure(patient.id)));
});

const getBloodPressure = createAsyncThunk<BloodPressureResponseDto[], string, AsyncThunkConfig>(
  'bloodPressure/getBloodPressure',
  async (patientId) => {
    return await getPatientBloodPressure(patientId);
  },
);

export { getPatientsBloodPressure, getBloodPressure };
